/** Runtime constants for leader report list modals (CRA resolves .js from .js imports). */

/** @typedef {"trade"|"first-deposit"|"normal-deposit"|"withdrawal"} LeaderReportListVariant */

export const LEADER_REPORT_LIST_ENDPOINTS = {
    trade: "/admin/leader-report/trade/list",
    "first-deposit": "/admin/leader-report/first-deposit/list",
    "normal-deposit": "/admin/leader-report/normal-deposit/list",
    withdrawal: "/admin/leader-report/withdrawal/list",
};

export const LEADER_REPORT_LIST_TITLES = {
    trade: "Trade List",
    "first-deposit": "First Deposit List",
    "normal-deposit": "Normal Deposit List",
    withdrawal: "Withdrawal List",
};
